import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { GrowlerType } from './growler.service';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export interface GrowlerInput
{
    title: string;
    message: string;
    type: GrowlerType;
    autoDismissAfter: number;
}

@Component({
    selector: 'app-growler',
    templateUrl: './growler.component.html',
    styleUrls: ['./growler.component.scss'],
    host: { class: 'growler-content' },
    standalone: true,
    imports: [
        MatIconModule,
        NgSwitch,
        NgSwitchCase,
        MatButtonModule,
        MatProgressBarModule,
    ],
})
export class GrowlerComponent implements OnInit
{
    progressBarInterval: NodeJS.Timer = null;
    percentRemaining = 100;

    readonly types = GrowlerType;

    constructor(
        private _snackRef: MatSnackBarRef<GrowlerComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: GrowlerInput,
    ) {
    }

    ngOnInit() {
        this.progressBarInterval = setInterval(() => {
            this.percentRemaining = this.percentRemaining - Math.floor(( 100 / (this.data.autoDismissAfter / 100)));
            if (this.percentRemaining < 0) {
                clearInterval(this.progressBarInterval);
            }
        }, 100);
    }

    dismiss() {
        if (this.progressBarInterval) {
            clearInterval(this.progressBarInterval);
            this.progressBarInterval = null;
        }
        this._snackRef.dismiss();
    }
}
